export default __webpack_public_path__ + "static/media/profile.c0f5e5b6.svg";